import { render, staticRenderFns } from "./view-page.vue?vue&type=template&id=3be6bdc4&"
import script from "./view-page.vue?vue&type=script&lang=js&"
export * from "./view-page.vue?vue&type=script&lang=js&"
import style0 from "./view-page.vue?vue&type=style&index=0&id=3be6bdc4&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports